// extracted by mini-css-extract-plugin
export default {"plan":"DealsCopyPlan_plan__NEMcG"};